import React, { useEffect, useState } from 'react'
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { Button, Form, Modal } from 'react-bootstrap';
import { MdAdd, MdDelete } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { addFutureSuggestion, addRemark, deleteFutureSuggestion, deleteRemark, getFutureSuggestion, getRemark, updateFutureSuggestion, updateRemark } from '../../../redux/actions/Doctor.action';
import { FaEdit } from 'react-icons/fa';
import { PiWarningCircleBold } from 'react-icons/pi';
import { TiInputChecked } from 'react-icons/ti';

const DoctorRemark = ({ patientIds }) => {

    const dispatch = useDispatch()
    const treatmentData = useSelector((state) => state.doctor)
    const [show, setShow] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [treatmentId, setTreatmentId] = useState();
    const type = localStorage.getItem('type')
    const toggle = () => { setShow(!show) }
    const deleteToggle = () => { setDeleteModal(!deleteModal) }
    const updateToggle = () => { setUpdateModal(!updateModal) }

    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(3);
    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    }

    const initialValues = {
        remark: ''
    }

    const [formData, setFormData] = useState({
        remark: ''
    })

    const validationSchema = Yup.object().shape({
        remark: Yup.string().required('Remark is required')
    });

    const handleSuggestion = (values, { resetForm }) => {
        const payload = {
            patientId: patientIds,
            remark: values.remark
        }
        dispatch(addRemark(payload, limits, patientIds)).then(() => {
            toggle();
            resetForm();
        });
    };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 3);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        treatmentData?.getRemark?.data?.totalCount / postPerPage,
    );

    const handleUpdate = (values) => {
        const payload = {
            patientId: patientIds,
            remark: values.remark
        }
        dispatch(updateRemark(payload, treatmentId, patientIds, limits)).then(() => {
            updateToggle()
        })
    }

    const handleDelete = () => {
        dispatch(deleteRemark(limits, patientIds, treatmentId)).then(() => {
            deleteToggle()
            setMainPage(1);
        })
    }

    useEffect(() => {
        if (patientIds) {
            dispatch(getRemark(limits, patientIds))
        }
    }, [mainPage, rowsPerPage, patientIds])

    return (
        <div className='col-lg-4'>

            <div className="!bg-[#fff] shadow p-4 rounded-4 mt-3">
                <div className="d-flex justify-between">
                    <div className="flex gap-3 items-center">
                        <TiInputChecked className="fs-5" />
                        <h6 className="mb-0">Doctor Remark</h6>
                    </div>

                    <div onClick={toggle} className="w-[30px] flex justify-center items-center h-[30px] rounded-circle !border-red-700 border-1 cursor-pointer">
                        <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><MdAdd className="fs-4 text-danger fw-bold" /></button>
                    </div>
                </div>
                <div className="mt-3">
                    <TableContainer>
                        <Table className="table-bordered">
                            <Thead className="!bg-theme-dark text-center">
                                <Tr>
                                    <Th className="!text-white">Date</Th>
                                    <Th className="!text-white">Remark</Th>
                                    <Th className="!text-white">User</Th>
                                    <Th className="!text-white">Action</Th>
                                </Tr>
                            </Thead>
                            <Tbody className="">
                                {
                                    treatmentData?.getRemark?.data?.remarksData?.length > 0 ? (
                                        treatmentData?.getRemark?.data?.remarksData?.map((res) => {
                                            return (
                                                <Tr key={res._id}>
                                                    <Td>{new Date(res.createdAt).toLocaleDateString()}</Td>
                                                    <Td>{res.remark}</Td>
                                                    <Td>{res?.authdata?.name}</Td>
                                                    <Td>
                                                        <div className='flex items-center gap-3'>
                                                            <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><FaEdit className='text-success' title='update' onClick={() => { updateToggle(); setTreatmentId(res?._id); setFormData(res) }} /></button>
                                                            <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><MdDelete className="text-danger" title="delete" onClick={() => { deleteToggle(); setTreatmentId(res?._id); }} /></button>
                                                        </div>
                                                    </Td>
                                                </Tr>
                                            )
                                        })
                                    ) : (
                                        <Tr>
                                            <Td colSpan={4} textAlign={'center'}> No any remark</Td>
                                        </Tr>
                                    )
                                }
                            </Tbody>
                        </Table>
                    </TableContainer>
                </div>
                <div className="flex justify-between items-center mt-2 text-sm">
                    <div>
                        Rows per page:
                        <select
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="ms-2 border rounded-md focus:outline-none"
                        >
                            <option value="" selected>Select</option>
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                    <ReactPaginate
                        breakLabel="..."
                        nextLabel=" >"
                        onPageChange={ChangeMainPage}
                        pageRangeDisplayed={5}
                        pageCount={PageCount}
                        previousLabel="< "
                        renderOnZeroPageCount={null}
                        className="pagination"
                    />
                </div>
            </div>

            {/* add */}
            <Modal show={show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Remark</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSuggestion}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Remark</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="remark"
                                                as='textarea'
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('remark', e.target.value)}
                                                value={values.remark}
                                                placeholder="Enter remark"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="remark"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* Update */}
            <Modal show={updateModal} onHide={updateToggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Remark</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpdate}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Remark</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="remark"
                                                rows={3}
                                                as='textarea'
                                                onChange={(e) =>
                                                    setFieldValue('remark', e.target.value)}
                                                value={values.remark}
                                                placeholder="Enter remark"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="remark"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete */}
            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className='p-5'>
                    <div>
                        <PiWarningCircleBold className='text-7xl w-100 text-danger' />
                    </div>
                    <div className='text-center mt-4'>
                        <h3>Are You Sure ?</h3>
                        <p className='text-md'>Do you really want to delete these records?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDelete}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default DoctorRemark;
